<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import Attribute from "./Attribute.svelte"
    import EqualityOperator from "./EqualityOperator.svelte"
    import Value from "./Value.svelte"
    import { _ } from "svelte-i18n"
    import { tooltip } from "../../../../helper"

    export let filter: PriceCalculationExceptionFilter
    let rebuilt = false
    const dispatch = createEventDispatcher()
</script>

<style lang="less" global>
    section.price-calc-filter {
        display: flex;
        align-items: stretch;
        width: 100%;
        gap: 1.2rem;
        padding: 0.3rem 0rem;
        .value-wrapper {
            input {
                margin: 0px !important;
            }
        }
        & > div {
            flex-grow: 2;
            width: 0px;
            min-height: 100%;
        }
        & > div:nth-child(2) {
            flex-grow: 1;
            width: 0px;
        }
        .svelte-select {
            height: unset !important;
            min-height: 100% !important;
            .multi-item {
                border-radius: 100px !important;
                background: #464646 !important;
                padding: 0px 12px !important;
                height: 30px !important;
                display: flex;
                align-items: center;
                max-height: 30px !important;
                .multi-item-text {
                    color: white !important;
                    max-height: 12px !important;
                    height: 12px !important;
                    min-height: 12px !important;
                    line-height: 12px !important;
                }
                .multi-item-clear {
                    color: white !important;
                    svg {
                        color: white !important;
                    }
                }
            }

            .value-container {
                overflow: visible !important;
                height: unset !important;
                display: flex !important;
                align-items: flex-start !important;
                padding: 10px;
            }
            &.multi {
                .value-container {
                    flex-direction: row-reverse !important;
                    justify-content: flex-end !important;
                    flex-wrap: wrap !important;
                    & > * {
                        order: 1;
                    }
                    input {
                        width: 100% !important;
                        flex-shrink: 0;
                        display: block;
                        order: 0;
                        min-width: 100% !important;
                        height: auto; /* Verhindert, dass es 100% der Höhe einnimmt */
                        box-sizing: border-box; /* Stellt sicher, dass Padding und Border die Größe korrekt beeinflussen */
                    }
                }
            }
            .indicators {
                & > div {
                    height: 100% !important;
                    font-weight: 300;
                    border-color: #9a9a9a !important;
                }
            }

            .selected-item {
                display: flex;
                flex-direction: column;
                .selection-label {
                    font-size: 12px !important;
                }
                .selection-value {
                    font-size: 18px !important;
                }
            }
        }
        & > button {
            background: none;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            & > span {
                display: none;
            }
        }

        @media (max-width: 1200px) {
            flex-direction: column;

            & > div {
                width: 100% !important;
            }
            & > button {
                & > span {
                    display: block;
                    margin-left: 0.5rem;
                    font-size: 1.2rem;
                    color: #9a9a9a;
                }
            }
        }
    }
</style>

<section class="price-calc-filter">
    <div data-cy="attribute-wrapper">
        <Attribute
            filter="{JSON.parse(JSON.stringify(filter))}"
            on:change="{(e) => {
                filter.attribute = e.detail.attribute
                filter.operator = 'eq'
                filter.stringArrayValues = []
                filter.numberValue = 0
                rebuilt = !rebuilt
            }}"
        />
    </div>
    {#key rebuilt}
        <div data-cy="operator-wrapper">
            <EqualityOperator bind:filter />
        </div>
        <div data-cy="value-wrapper">
            <Value bind:filter />
        </div>
    {/key}
    <button
        on:click|stopPropagation|preventDefault="{() => dispatch('remove')}"
        use:tooltip="{{
            content: $_('general.removeExceptionFilter'),
        }}"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
                d="M12 20.5C7.59 20.5 4 16.91 4 12.5C4 8.09 7.59 4.5 12 4.5C16.41 4.5 20 8.09 20 12.5C20 16.91 16.41 20.5 12 20.5ZM12 2.5C6.47 2.5 2 6.97 2 12.5C2 18.03 6.47 22.5 12 22.5C17.53 22.5 22 18.03 22 12.5C22 6.97 17.53 2.5 12 2.5ZM14.59 8.5L12 11.09L9.41 8.5L8 9.91L10.59 12.5L8 15.09L9.41 16.5L12 13.91L14.59 16.5L16 15.09L13.41 12.5L16 9.91L14.59 8.5Z"
                fill="#9A9A9A"
            ></path>
        </svg>
        <span>{$_("components.pcalc.removeFilter")}</span>
    </button>
</section>
